import styled from "styled-components";

export const ResultContainer = styled("div")(({ theme, $type }) => ({
  flex: "1",

  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 8,

  padding: 16,
  border: `2px solid
    ${$type === "no-data" ? "#f6ad55" : $type === "visa_required" ? "#fc8181" : "#68d391"}`,
  borderRadius: 16,
  backgroundColor: `${$type === "no-data" ? "#fffaf5" : $type === "visa_required" ? "#fed7d7" : "#f0fff4"}`,
}));

export const ResultStatusBlock = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
}));

export const ResultImg = styled("img")(({ theme }) => ({}));

export const ResultStatus = styled("div")(({ theme, $type }) => ({
  fontSize: 18,
  fontWeight: 600,
  marginBottom: 12,
  color: `${$type === "no-data" ? "#c05621" : $type === "visa_required" ? "#c53030" : "#2f855a"}`,
}));

export const ResultMessage = styled("p")(({ theme }) => ({
  margin: 0,
  fontSize: 15,
  lineHeight: 1.5,
  color: "#4a5568",
}));

export const LoadingContainer = styled("div")(({ theme }) => ({
  flex: "1",
  padding: "40px 20px",
  color: "#718096",
  fontSize: 16,
}));

export const LoadingEmoji = styled("div")(({ theme }) => ({
  fontSize: 24,
  marginBottom: 12,
}));

export const EmptyStateContainer = styled("div")(({ theme }) => ({
  flex: "1",

  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 8,

  padding: "32px 24px",
  border: "2px dashed #e2e8f0",
  borderRadius: 16,
  backgroundColor: "#f8fafc",
  textAlign: "center",
}));

export const EmptyStateTitle = styled("h3")(({ theme }) => ({
  fontSize: 18,
  fontWeight: 600,
  color: "#718096",
  margin: "0 0 8px 0",
}));

export const EmptyStateMessage = styled("p")(({ theme }) => ({
  fontSize: 14,
  color: "#a0aec0",
  margin: 0,
  lineHeight: 1.5,
}));

export const PartialStateContainer = styled("div")(({ theme }) => ({
  flex: "1",

  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 8,

  padding: 16,
  border: "2px dashed #fbb6ce",
  borderRadius: 16,
  backgroundColor: "#fffaf8",
  textAlign: "center",
}));

export const PartialStateIcon = styled("div")(({ theme }) => ({
  fontSize: 32,
  marginBottom: 12,
}));

export const PartialStateMessage = styled("div")(({ theme }) => ({}));
